import React, {Component} from "react";
import {
	Box,
	Tooltip,
	SpeedDial,

	Backdrop,
	CircularProgress
} from "@mui/material";
import {
	withStyles
} from "@mui/styles";
import {
	PersonAddAltRounded as PersonAddAltRoundedIcon
} from "@mui/icons-material";
import {
	Table as TableComponent,
	Filter as FilterComponent,
	DialogCreateMechanic as DialogCreateMechanicComponent
} from "./components";
import {
	Notification,
	notificationTypes
} from "../../../common/Notification";
import agent from "../../../agent/agent";
import {phoneFormat} from "../../../helper/formater";
import {
	DialogConfirmation
} from "../../../components";
import moment from "moment";

const initFilter = {
	last_name: "",
	first_name: "",
	patronymic: "",
	phone: "",

	role: "",
	page: 1
}

class Mechanics extends Component {
	constructor(props) {
		super(props);

		this.state = {
			mechanics: [],
			initMechanics: [],

			filter: {...initFilter},

			totalPage: 0,
			totalCount: 0,

			isLoad: true,
			isShowBackdrop: false,
		};

		this.refDialogConfirmation = React.createRef();
		this.refDialogCreateMechanic = React.createRef();
	}

	componentDidMount = async () => {
		await this.getMechanics();
	}

	getMechanics = async () => {
		await this.setState({ isLoad: true });

		const filter = this.getFilter();
		const response = await agent.get(`/user/admin/mechanics?${ filter }`).then((res) => {
			return res.data
		}).catch((err) => {
			return null
		});

		this.setState({
			isLoad: false,

			totalCount: response?.total,
			totalPage: response.last_page,
			mechanics: response?.data || [],
		})
	}

	getFilter = () => {
		let _filterStr = [
			'limit=20'
		];

		const filter = {...this.state.filter};
		Object.keys(filter).map((filterKey) => {
			const filterValue = filter[filterKey];
			if (!!filterValue) {
				_filterStr.push(`${ filterKey }=${ filterValue }`);
			}
		})

		return _filterStr.join('&')
	}
	resetFilter = async () => {
		await this.setState({filter: {...initFilter}});
		await this.getMechanics();
	}
	changeFilter = async (filter) => {
		await this.setState({ filter });
		await this.getMechanics();
	}
	changeFilterPages = async (newPage) => {
		let filter = {...this.state.filter};
		filter.page = newPage;
		await this.setState({ filter });
		await this.getMechanics();
	}

	createMechanic = async (form = null, editForm = null) => {
		if (!form) {
			this.refDialogCreateMechanic.current.open({
				onSubmit: this.createMechanic.bind(this),
				editForm: editForm
			});

			return null
		}

		this.setState({isShowBackdrop: true})

		const response = await agent.post(`/user/admin/mechanics`, form).then((res) => {
			return res.data
		}).catch((err) => {
			return {error: err.response}
		})
		if (response.error) {
			this.setState({isShowBackdrop: false})

			Notification({
				type: notificationTypes.error,
				message: response.error.data?.details || "Ошибка сервера"
			})

			return null
		}

		await this.getMechanics();
		this.refDialogCreateMechanic.current.close();

		Notification({
			type: notificationTypes.success,
			message: "Пользователь успешно добавлен"
		})

		this.setState({isShowBackdrop: false})
	}
	editMechanic = async (form, isSubmit = false) => {
		if (!isSubmit) {
			const editForm = {...form};
			editForm.phone = phoneFormat(form.phone);
			delete editForm.createdAt;
			delete editForm.updatedAt;

			this.refDialogCreateMechanic.current.open({
				onSubmit: this.editMechanic.bind(this),
				editForm: editForm
			});

			return null
		}

		this.setState({ isShowBackdrop: true })

		const response = await agent.put(`/user/admin/${ form.id }`, form).then((res) => {
			return res.data
		}).catch((err) => {
			return { error: err.response }
		})
		if (response.error) {
			this.setState({isShowBackdrop: false})

			Notification({
				type: notificationTypes.error,
				message: response.error.data?.details || "Ошибка сервера"
			})

			return null
		}

		await this.getMechanics();
		this.refDialogCreateMechanic.current.close();

		Notification({
			type: notificationTypes.success,
			message: "Пользователь успешно изменен"
		})

		this.setState({isShowBackdrop: false})
	}
	removeMechanic = async (user, isConfirm) => {
		if (!isConfirm) {
			this.refDialogConfirmation.current.onOpen({
				message: `Вы действиетельно хотите удалить пользователя "${[user?.lastName, user?.firstName].filter((t) => !!t).join(' ')}"?`,
				acceptButtonAction: this.removeMechanic.bind(this, user, true),
				acceptButtonTitle: "Да, удалить"
			})
			return
		}

		await this.setState({ isShowBackdrop: true });
		const res = await agent.delete(`/user/admin/delete/${ user?.id }`)
			.then((res) => {
				return res.data
			}).catch((err) => {
				return {error: err.response || true}
			})
		if (res?.error) {
			await this.setState({ isShowBackdrop: false });
			Notification({
				type: notificationTypes.error,
				message: "Ошибка удаления пользователя"
			})
			return
		}
		await this.getMechanics();
		await this.setState({ isShowBackdrop: false });
		Notification({
			type: notificationTypes.success,
			message: "Пользователь успешно удален"
		})
	}

	render() {
		const {
			classes
		} = this.props;
		const {
			mechanics,

			filter,
			totalPage,
			totalCount,

			isLoad,
			isShowBackdrop
		} = this.state;

		return (
			<>

				<FilterComponent
					initFilter={filter}
					onChange={this.changeFilter}
					onReset={this.resetFilter}
				/>

				<Box className={classes.root}>
					<TableComponent
						data={mechanics}
						isLoad={isLoad}
						filter={filter}
						totalPage={totalPage}

						onChange={this.changeFilter}
						onChangePage={this.changeFilterPages}
						onEditMechanic={this.editMechanic}
						onRemoveMechanic={this.removeMechanic}
					/>
				</Box>


				<Tooltip title="Добавить пользователя" arrow>
					<SpeedDial
						ariaLabel="Добавить пользователя"
						sx={{position: 'fixed', bottom: 24, right: 24}}
						icon={<PersonAddAltRoundedIcon/>}
						onClick={this.createMechanic.bind(this, null, null)}
					/>
				</Tooltip>

				<DialogCreateMechanicComponent
					ref={this.refDialogCreateMechanic}
				/>
				<DialogConfirmation ref={this.refDialogConfirmation}/>

				<Backdrop open={isShowBackdrop}>
					<CircularProgress></CircularProgress>
				</Backdrop>

			</>
		);
	}
}

const styles = {
	root: {
		padding: 20,
		boxSizing: "border-box",
		backgroundColor: "white",
		borderRadius: 14,
		border: "1px solid #F0F0F0",

		"@media(max-width: 1199px)": {
			padding: 0,
			borderRadius: 0,
			border: "none",
			backgroundColor: "transparent",
		}
	}
}
Mechanics = withStyles(styles)(Mechanics)

export default Mechanics
